import _styled from "styled-components";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function CurrentLocationPinControlButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    className: "control-panel",
    children: /*#__PURE__*/_jsxs(_StyledButton, {
      onClick: onClick,
      className: "mapboxgl-ctrl-current-location-pin",
      children: [/*#__PURE__*/_jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        className: "w-6 h-6",
        children: [/*#__PURE__*/_jsx("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
        }), /*#__PURE__*/_jsx("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
        })]
      }), /*#__PURE__*/_jsx(_StyledDiv2, {
        children: "Torna al locale"
      })]
    })
  });
}

export default /*#__PURE__*/React.memo(CurrentLocationPinControlButton);

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "location-pin-control-button___StyledDiv",
  componentId: "sc-1ddfn7v-0"
})({
  "position": "relative",
  "top": "39px",
  "left": "calc(100% - 195px)",
  "zIndex": "10",
  "width": "fit-content",
  "borderRadius": "0.25rem",
  "--tw-shadow": "0 0 0 2px rgba(0,0,0,.1)",
  "--tw-shadow-colored": "0 0 0 2px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "location-pin-control-button___StyledButton",
  componentId: "sc-1ddfn7v-1"
})({
  "display": "flex",
  "height": "29px",
  "width": "fit-content",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "location-pin-control-button___StyledDiv2",
  componentId: "sc-1ddfn7v-2"
})({
  "marginLeft": "8px",
  "marginRight": "8px"
});